export const baseUrlParams = ['q', 'sfs', 'sfn'];
/*
 * Extracts the query (q), safe-search (sfs, sfn) from the url query.
 */
export const getUrlQuery = (query = {}, urlParams = baseUrlParams) => urlParams
  .reduce((acc, key) => {
    const value = query[key];
    return value ? { ...acc, [key]: value } : acc;
  }, {});
